import { css } from '@emotion/react';

export const styles = {
  list: css`
    display: flex;
    flex-direction: column;
    gap: 16px;
  `,

  card: css`
    border-radius: 20px;
    border: 1px solid #e5e7eb;
    background: #ffffff;
    cursor: pointer;
    overflow: hidden;
    transition: 0.2s;

    &:hover {
      border-color: #c4b5fd;
    }
  `,

  empty: css`
    width: 100%;
    padding: 40px 0;
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
    color: #111827;
  `,
};
